import { createReducer, on } from '@ngrx/store';
import { Merchant } from '@print2go/types';
import {
  loadMerchant,
  loadMerchantSuccess,
  loadMerchantFailure,
  updateMerchant,
  updateMerchantFailure,
  updateMerchantSuccess,
} from '../actions/merchant.actions';

export interface MerchantState {
  merchant: Merchant | null;
  loading: boolean;
  error: any;
  isUpdating: boolean;
}

export const initialState: MerchantState = {
  merchant: null,
  loading: true,
  error: null,
  isUpdating: false,
};

export const merchantReducer = createReducer(
  initialState,
  on(loadMerchant, (state): MerchantState => {
    return { ...state, loading: true };
  }),
  on(loadMerchantSuccess, (state, { merchant: merchantData }): MerchantState => {
    const merchantBefore = state.merchant;
    const merchant = merchantData ? { ...merchantBefore, ...merchantData } : null;
    return { ...state, loading: false, merchant };
  }),
  on(loadMerchantFailure, (state, { error }): MerchantState => {
    return { ...state, loading: false, error };
  }),
  on(updateMerchant, (state, { data }): MerchantState => {
    const { uid } = data;
    if (!state.merchant) {
      throw new Error('Merchant in store is null');
    }
    if (state.merchant.uid !== uid) {
      throw new Error(`Merchant in store (${state.merchant.uid}) does not match merchant id (${uid})`);
    }

    const isUpdating = true;
    return {...state, isUpdating };
  }),
  on(updateMerchantSuccess, (state, { data }): MerchantState => {
    const { uid, ...merchantUpdates } = data;
    const merchantBefore = state.merchant;
    const merchant = { ...merchantBefore, ...merchantUpdates, uid };
    const isUpdating = false;
    const error = null;
    return {
      ...state,
      merchant,
      error,
      isUpdating,
    };
  }),
  on(updateMerchantFailure, (state, { error }): MerchantState => {
    const isUpdating = false;
    return {
      ...state,
      error,
      isUpdating,
    };
  }),
);